import OriginalBreadcrumbs from './Breadcrumbs.svelte';
import OriginalCrumb from './Crumb.svelte';
import Icon from '../icon/Icon.svelte';
import Label from './Label.svelte';
import Divider from './Divider.svelte';
const Breadcrumbs = OriginalBreadcrumbs;
Breadcrumbs.Crumb = OriginalCrumb;
Breadcrumbs.Crumb.Icon = Icon;
Breadcrumbs.Crumb.Label = Label;
Breadcrumbs.Crumb.Divider = Divider;
export default Breadcrumbs;
